import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "9",
  r: "2",
  fill: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "m12 21.5-.351.356a.5.5 0 0 0 .702 0L12 21.5Zm6.5-11.938c0 1.15-.403 2.446-1.044 3.769-.638 1.317-1.493 2.625-2.357 3.788a39.676 39.676 0 0 1-3.432 4.007l-.014.014-.004.003v.001L12 21.5l.351.356.002-.002.004-.004.016-.016a14.334 14.334 0 0 0 .288-.294 40.666 40.666 0 0 0 3.24-3.825c.886-1.193 1.78-2.556 2.455-3.948.672-1.387 1.144-2.84 1.144-4.205h-1ZM12 21.5l.351-.356-.004-.004-.014-.014a12.497 12.497 0 0 1-.274-.28 39.683 39.683 0 0 1-3.158-3.728c-.864-1.162-1.72-2.47-2.357-3.787C5.903 12.008 5.5 10.71 5.5 9.56h-1c0 1.365.472 2.819 1.144 4.206.674 1.393 1.569 2.755 2.455 3.948a40.653 40.653 0 0 0 3.528 4.119l.016.016.004.004.001.001L12 21.5ZM5.5 9.562c0-2.114.731-3.744 1.885-4.846C8.544 3.61 10.165 3 12 3V2c-2.057 0-3.937.686-5.305 1.993C5.322 5.303 4.5 7.205 4.5 9.562h1ZM12 3c1.836 0 3.456.61 4.615 1.716C17.769 5.818 18.5 7.448 18.5 9.562h1c0-2.357-.822-4.258-2.195-5.57C15.937 2.687 14.057 2 12 2v1Z",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }